// extracted by mini-css-extract-plugin
export default {"ZoomSlider":"ZoomSlider_ZoomSlider__kxtg5"};